<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ this.$store.state.auth }} -->
    <div class="w100">
      <div class="row mb-3">
        <div class="col">
          <label for="Label" class="form-label">名前</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="アカウント名"
            v-model="manage_account.label"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <label for="Label" class="form-label">ログインID</label>
          <input
            type="text"
            class="form-control"
            id="Login"
            placeholder="ログインID"
            v-model="manage_account.login"
          />
        </div>
        <div class="col">
          <label for="Label" class="form-label">パスワード</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              id="Pass"
              placeholder="パスワード"
              v-model="manage_account.pass"
              :disabled="disabledChk"
            />
            <div class="input-group-text">
              <input
                class="form-check-input mt-0"
                type="checkbox"
                id="pass_chg_flg_check"
                v-model="manage_account.pass_chg_flg"
                aria-label="パス変更"
              />
              <label class="small ps-2" for=" pass_chg_flg_check"
                >変更する</label
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <label for="Label" class="form-label">レベル</label>
          <bs-select
            :options="manage_account_level"
            :nullOption="true"
            v-model="manage_account.level"
          ></bs-select>
        </div>
        <div class="col">
          <label for="Label" class="form-label">管理権限</label>
          <bs-select
            :options="manage_role_list"
            :nullOption="true"
            v-model="manage_account.manage_role_id"
          ></bs-select>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center">
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
// import '../../assets/bootstrap/css/sc.css';
import axios from 'axios'
import config from '../../../const'

export default {
  name: 'StaffDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'データ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      manage_account: {},
      manage_account_level: [
        {
          key: 0,
          label: '管理者'
        },
        {
          key: 10,
          label: '制限'
        }
      ],
      manage_role_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsCheckBox,
  },
  methods: {
    // chg_level() {
    //   if (this.manage_account.level == 0) {
    //     const tmps = []
    //     Object.values(this.clinic_list).forEach(clinic => {
    //       tmps.push({
    //         stat: 0,
    //         manage_id: this.manage_account.id,
    //         clinic_id: clinic.id
    //       })
    //     })
    //     this.manage_account.relations = tmps
    //   } else if (this.manage_account.level >= 100) {
    //     const tmps = []
    //     this.manage_account.relations = tmps
    //   }
    //   this.$forceUpdate()
    // },
    async attachData(target) {
      if (this.manage_account.level < 100) {
        await this.attachDataAction(target)
      } else {
        const tmps = []
        this.manage_account.relations = tmps
        await this.attachDataAction(target)
      }
    },
    async attachDataAction(target) {
      if (this.dataClassChk(target)) {
        const index = this.manage_account.relations.findIndex(relation => {
          return relation.clinic_id == target
        })
        const tmp = [...this.manage_account.relations]
        tmp.splice(index, 1)
        this.manage_account.relations = tmp
      } else {
        console.log('attachData nashi', target)
        const relation = {
          stat: 0,
          manage_id: this.manage_account.id,
          clinic_id: target
        }
        this.manage_account.relations.push(relation)
      }
      this.$forceUpdate()
    },
    async loadManage() {
      const params = {}
      params['id'] = this.targetid
      await axios
        .post(
          config.BASE_API_URL + '/manage_account/lists',
          this.setParams_S(params),
          this.cHeader
        )
        .then(async response => {
          console.log('loadStaff', response)
          this.manage_account =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
          this.manage_account.pass_chg_flg = 'false'
          this.manage_account.pass = ''
        })
        .catch(async err => {
          console.log(err)
          this.manage_account = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadManageRoleList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/manage_role/lists',
        params
      )
        .then(async response => {
          console.log('loadManageRoleList response', response)
          this.manage_role_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.manage_role_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadManageAccountLevel() {
      // console.log('tag');
      return this.$store
        .dispatch('fetchBasicLists', {
          data: {},
          target: 'manage_account_level'
        })
        .catch(err => Promise.reject(err))
        .then(() => {})
        .finally(() => {})
    },
    update() {
      console.log('component methods', this.manage_account)
      return this.$store
        .dispatch('updateBasic', {
          data: this.manage_account,
          target: 'manage_account'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadManage()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({
      // manage_account_level: state => state.apidata.manage_account_level
    }),
    manage_role_list: function () {
      return this.manage_role_obj ? this.manage_role_obj : []
    },
    disabledChk: function () {
      if (
        this.manage_account.pass_chg_flg == 'false' ||
        this.manage_account.pass_chg_flg == false
      ) {
        return true
      } else {
        return false
      }
    },
    dataClassChk: function () {
      const manage_account = this.manage_account
      return function (clinic_id) {
        if (
          typeof manage_account === 'object' &&
          typeof manage_account.relations === 'object' &&
          manage_account.relations.find(rel => {
            return rel.clinic_id == clinic_id
          })
        ) {
          return true
        }
        return false
      }
    },
    dataClass: function () {
      const dataClassChk = this.dataClassChk
      return function (clinic_id) {
        if (dataClassChk(clinic_id)) {
          return 'btn-primary'
        }
        return 'btn-light btn-outline-secondary'
      }
    }
  },

  async created() {
    // await this.loadClinicList()
    await this.loadManageRoleList()
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadManage()
      this.btnLabel = '更新'
    } else {
      this.manage_account = {
        id: 0,
        label: '',
        level: 0,
        sort: 0,
        login: '',
        pass: '',
        pass_chg_flg: 'false',
        relations: []
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
    // const ret = !Number.isNaN(this.targetid)
    //   ? {...this.$store.getters.getDepartmentById(this.targetid)}
    //   : {};
    // this.department = ret;
  },
  mounted: function () {
    this.fromParentTitle = '管理アカウントデータ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
